import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ListItemIcons } from '../../../ListItem'

import { QA_NAME_DELETE_RESPONSIBLE_MANAGER_BTN } from './ProfileResponsibleManagersWidgetItemIcons.constants'

import * as styles from './ProfileResponsibleManagersWidgetItemIcons.module.css'

import DeleteIcon from '../../../../icons/delete.svg'

function ProfileResponsibleManagersWidgetItemIcons({
  canDelete,
  deleteButtonQaName = QA_NAME_DELETE_RESPONSIBLE_MANAGER_BTN,
  isDeleting,
  isDisabled,
  isHovered,
  onDelete,
  onIconMouseEnter,
  onIconMouseLeave,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <div
      className={styles.ProfileResponsibleManagersWidgetItemIcons}
      onMouseEnter={onIconMouseEnter}
      onMouseLeave={onIconMouseLeave}
    >
      <ListItemIcons {...restProps}>
        {canDelete && (isHovered || isDeleting) ? (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: DeleteIcon }}
            disabled={isDisabled}
            height={BUTTON_HEIGHT_32}
            isLoading={isDeleting}
            qaName={deleteButtonQaName}
            tooltip={t('Modal.DeleteBtnKey')}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={onDelete}
          />
        ) : null}
      </ListItemIcons>
    </div>
  )
}

export default ProfileResponsibleManagersWidgetItemIcons
